var $2b6e161c9edcf319$exports = {};
// import * as bootstrap from 'bootstrap';
let $2b6e161c9edcf319$var$mobileMenuToggle;
let $2b6e161c9edcf319$var$mobileNav;
$2b6e161c9edcf319$var$mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
$2b6e161c9edcf319$var$mobileNav = document.querySelector(".mobile-nav");
$2b6e161c9edcf319$var$mobileMenuToggle.addEventListener("click", ()=>{
    if (!document.startViewTransition) {
        $2b6e161c9edcf319$var$mobileNav.classList.toggle("mobile-nav-show");
        return;
    }
    // With a View Transition:
    document.startViewTransition(()=>$2b6e161c9edcf319$var$mobileNav.classList.toggle("mobile-nav-show"));
});
const $2b6e161c9edcf319$var$activePath = window.location.pathname;
const $2b6e161c9edcf319$var$navLinks = document.querySelectorAll(".navbar-links-a");
$2b6e161c9edcf319$var$navLinks.forEach((link)=>{
    if (link.getAttribute("href") === $2b6e161c9edcf319$var$activePath) link.classList.add("active");
});


//# sourceMappingURL=graftedinshelterv2.bb026cf9.js.map
